export default {
  "header": {
    "hi": "Hi",
    "logout": "Logout",
    "profile": "Edit Profile",
    "admin": "Admin",
    "onboard": "Onboard Again"
  },
  "onboarding": {
    "title": "Welcome",
    "next": "Next",
    "previous": "Previous",
    "startLearning": "Start Learning",
    "finish": "Finish",
    "welcome": {
      "title": "Welcome to Grow With Us!"
    },
    "terms": {
      "title": "Terms & Conditions",
      "description": "Please read and accept Terms & Conditions.",
      "body": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>",
      "accept": "Accept"
    },
    "complete": {
      "imgAlt": "All done with onboarding",
      "title": "You are All Done!"
    }
  },
  "home": {
    "hero": {
      "text": "Imaginer <br/> l'avenir </ br> tu veux, puis le créer.",
      "play": "LIRE LA VIDÉO"
    },
    "takeCareChampion": "POUR TAKECARE CHAMPIONS",
    "activation": {
      "title": "ACTIVATION",
      "descriptionHtml": "En tant que <b>responsable immobilier</ b> ou <b>TakeCare Champion </ b>, vous êtes chargé de guider les collaborateurs dans cette aventure et de les inspirer pour leur croissance. Nous avons créé des ressources pour aider.",
      "action": "APPRENDRE ENCORE PLUS"
    },
    "coaching": {
      "title": "ENCADREMENT",
      "descriptionHtml": "Le coaching aide les collaborateurs à retrouver leur statut actuel ou futur.",
      "action": "APPRENDRE ENCORE PLUS"
    },
    "pathway": {
      "section": {
        "learningHowToLearn": {
          "title": "Apprendre à apprendre.",
          "description": "Commencez ici pour comprendre les compétences et les mentalités nécessaires à la croissance et à l’apprentissage continu tout au long de la vie."
        },
        "mindfulness": {
          "title": "Préparez votre esprit.",
          "description": "Apprenez à mettre <b> l'accent </ b> sur votre vie, à améliorer votre bien-être mental et physique et à devenir plus conscient et détendu."
        },
        "resilience": {
          "title": "Êtes-vous prêts à relever le défi?",
          "description": "Apprenez à <b> recharger </ b>, à rester positif et proactif, à agir et à penser de manière équilibrée et à faire preuve d'empathie envers les autres."
        },
        "grow": {
          "title": "Continuer à grandir.",
          "description": "Cette collection de \"chemins\" a été conçue pour vous aider à ressentir le <b> bien-être </ b>, à accélérer le <b> développement personnel </ b> et à acquérir des <b> compétences professionnelles </ b>."
        }
      }
    }
  },
  "pathway": {
    "playbook": {
      "back": "BACK"
    },
    "card": {
      "count": "%{topicCount} topics, %{assetCount} assets",
      "inThisPathway": "IN THIS PATHWAY:"
    },
    "category": {
      "Wellbeing": "WELLBEING",
      "Professional Skills": "PROFESSIONAL SKILLS",
      "Personal Development": "PERSONAL DEVELOPMENT"
    }
  },
  "playbook": {
    "item": {
      "takeaway": "TAKEAWAY",
      "setting": "SETTING",
      "setup": "SET UP",
      "technique": "TECHNIQUE",
      "back": "BACK"
    }
  },
  "activation": {
    "back": "BACK",
    "title": "Activating TakeCare Grow",
    "subtitle": "Below are materials and resources to help you activate and promote TakeCare Grow at your location!",
    "descriptionHtml": "<p><b>TakeCare Grow</b> is an online platform that helps associates grow their skillsets to thrive in their career and life. Mobile-capable, TakeCare Grow gives associates access to insights, exclusive tools and video-based learning resources anytime, anywhere.</p><p>As traditional jobs change and new roles emerge, TakeCare Grow unlocks the knowledge and expertise of associates to prioritize their continuous learning and prepare them for the future of work.</p><p>Download the library of materials to help you activate TakeCare Grow at your location. Materials are editable for you to customize as needed.</p>",
    "downloadTitle": "Downloadable Toolkit",
    "downloadSubtitle": "For Property Leaders and Champions"
  },
  "profile": {
    "title": "Edit Settings",
    "details": {
      "title": "Details"
    },
    "language": {
      "title": "Language",
      "instructions": "Please select your preferred <b>language</b>.",
      "unsupportedLanguage": "Your selected language is not available yet. Please check back soon."
    },
    "country": {
      "title": "Country",
      "instructions": "Please select your <b>country</b>."
    },
    "role": {
      "title": "Take Care Champion or Property Leader?",
      "instructions": "Are you a take care champion or a property leader?"
    }
  },
  "resource": {
    "tile": {
      "viewed": "Viewed",
      "completed": "Completed",
      "markComplete": "Mark Complete"
    },
    "types": {
      "display": {
        "book": "Book",
        "video": "Video",
        "app": "App",
        "activity": "Activity",
        "article": "Article",
        "course": "Course",
        "ebook": "eBook",
        "elearning": "E-Learning App",
        "mooc": "Course",
        "podcast": "Podcast",
        "tool": "Online Tool",
        "website": "Website",
        "tool-phone": "Phone App",
        "video-activity": "Video Activity",
        "videos": "Video",
        "videos-activity": "Video Activity"
      },
      "action": {
        "book": "Read",
        "video": "Watch Video",
        "app": "Go to App",
        "activity": "Go to Activity",
        "article": "Read Article",
        "course": "Go to Course",
        "ebook": "Read eBook",
        "elearning": "Go to E-Learning App",
        "mooc": "Go to Course",
        "podcast": "Listen to Podcast",
        "tool": "Go to Tool",
        "website": "View Website",
        "tool-phone": "Go to Phone App",
        "video-activity": "Go to Video Activity",
        "videos": "Watch",
        "videos-activity": "Go to Video Activity"
      }
    }
  },
  "admin": {
    "title": "Admin",
    "rights": {
      "title": "User Privileges",
      "description": "Assign specifc users admin and/or editor privileges.",
      "back": "Back to Admin",
      "getUser": {
        "title": "First get the user",
        "label": "Type in the username of the person you want to edit",
        "button": "Submit"
      },
      "updateUser": {
        "title": "User Privilages: %{userNameDisplay}",
        "button": "Update User Privileges"
      },
      "admin": {
        "title": "Make Admin",
        "canEditTitle": "Can Edit Privileges",
        "canEditDescription": "Can edit the privileges of other users (use this page).",
        "canMakeAdminTitle": "Can Make Others Admin",
        "canMakeAdminDescription": "Can give others the ability to edit privileges."
      },
      "lang": {
        "title": "Site Language",
        "canEditAllTitle": "Can Edit All Languages",
        "canEditAllDescription": "Can make updates all available site language labels."
      }
    },
    "lang": {
      "title": "Site Language",
      "description": "Manage translations for various languages for labels that appear on this website.",
      "back": "Back to Admin",
      "new": "Add New language",
      "table": {
        "language": "Language",
        "code": "Code",
        "actions": "Actions",
        "download": "Download CSV",
        "upload": "Update"
      },
      "add": {
        "title": "Add New Site Language Translations",
        "description": "Select the language you want to add and upload a CSV file with label translations.",
        "back": "Back to Site Language Admin",
        "language": "Select Language",
        "download": "Download CSV template file to edit",
        "upload": "Upload CSV file",
        "submit": "Submit",
        "success": "Language added successfully!"
      },
      "update": {
        "title": "Update Site Language Translations",
        "description": "Description",
        "back": "Back to Site Language Admin",
        "language": "Updating Language",
        "code": "Language Code",
        "download": "Download existing CSV file to edit",
        "upload": "Upload CSV file",
        "submit": "Submit",
        "success": "Language updated successfully!"
      }
    }
  },
  "forbidden": {
    "title": "Sorry!",
    "body": "Looks like you do not have access to this page!",
    "goHome": "Go to the Home Page"
  }
};



// WEBPACK FOOTER //
// ./src/lang/phrases_fr.js